import { VIDEO_RECORDING } from './constants';

export default class ShipmentRecorder {
  constructor(stream, mimeType, shipmentId) {
    this.shipmentId = shipmentId;
    this.mimeType = mimeType;
    this.chunks = [];
    this.blob = null;
    this.startedAt = null;
    this._resolveStop = null;

    this.recorder = new MediaRecorder(stream, {
      mimeType,
      videoBitsPerSecond: 1_000_000,
    });

    this.recorder.ondataavailable = e => {
      if (e.data.size > 0) this.chunks.push(e.data);
    };

    this.recorder.onstop = () => {
      this.blob = new Blob(this.chunks, { type: this.mimeType });
      this.chunks = [];
      if (this._resolveStop) this._resolveStop(this.blob);
    };

    this.recorder.onerror = () => {
      if (this._resolveStop) this._resolveStop(null);
    };
  }

  start() {
    this.startedAt = Date.now();
    this.recorder.start(1000);
  }

  stopWithDelay() {
    return new Promise(resolve => {
      this._resolveStop = resolve;
      setTimeout(() => {
        if (this.recorder.state === 'recording') {
          this.recorder.stop();
        } else {
          resolve(this.blob);
        }
      }, VIDEO_RECORDING.POSTROLL_DELAY_MS);
    });
  }

  abort() {
    const resolve = this._resolveStop;
    this._resolveStop = null;
    if (this.recorder.state === 'recording') {
      this.recorder.stop();
    }
    if (resolve) resolve(null);
  }

  getDurationMs() {
    if (!this.startedAt) return 0;
    return Date.now() - this.startedAt;
  }
}
